import { defineStore } from 'pinia'
import { useRequest } from 'composables/useRequest.js'

const CACHE_TTL = 5 * 60 * 1000

export const useQuestionsStore = defineStore('questions', {
  state: () => ({
    questions: [],
    fetchedAt: null,
    loading: false,
    error: null,
  }),

  getters: {
    isCacheValid: (state) =>
      state.fetchedAt !== null && Date.now() - state.fetchedAt < CACHE_TTL,
  },

  actions: {
    async fetchIfStale() {
      if (this.isCacheValid) return
      await this.fetchQuestions()
    },

    async fetchQuestions() {
      this.loading = true
      this.error = null
      try {
        const { axiosRequest } = useRequest()
        const res = await axiosRequest('GET', '/api/v1/host/questions', {}, false)
        if (!res.js_error && res.response.success) {
          this.questions = res.response.data
          this.fetchedAt = Date.now()
        } else {
          this.error = 'Failed to load questions.'
        }
      } catch {
        this.error = 'Something went wrong.'
      } finally {
        this.loading = false
      }
    },

    addQuestion(question) {
      this.questions.push(question)
      this.questions.sort((a, b) => a.title.toLowerCase().localeCompare(b.title.toLowerCase()))
      this.fetchedAt = Date.now()
    },

    updateQuestion(id, patch) {
      const idx = this.questions.findIndex((q) => q.id === id)
      if (idx !== -1) Object.assign(this.questions[idx], patch)
      this.questions.sort((a, b) => a.title.toLowerCase().localeCompare(b.title.toLowerCase()))
      this.fetchedAt = Date.now()
    },

    removeQuestion(id) {
      this.questions = this.questions.filter((q) => q.id !== id)
      this.fetchedAt = Date.now()
    },

    invalidate() {
      this.fetchedAt = null
    },
  },
})
